import React from "react";
import "./Videotitle.css";

const Video = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          // minWidth: "100%",
          // minHeight: "100%",
          transform: "translate(-50%, -50%)",
          objectFit: "cover",
        }}
      >
        {/* <source src="./images/video.mp4" type="video/mp4" /> */}
        Your browser does not support the video tag.
      </video>

      <div style={{
          position: "absolute",
         
         
        }}> 
           <img src="./images/spst-1.jpg" alt="logo" className="homeimage" style={{ width: '100%' }} />
      </div>

     

      {/* Overlay Content (optional) */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          alignItems: "center",
          color: "#fff",
          textAlign: "center",
          background: "rgba(0,0,0,0.3)", // slight dark overlay

        }}

      >
       
        <div className="fullscreen-menu-header">

          <div className="temple-title" >

            <div className="temple-symbol-" style={{width:'100px'}}>
              {/* <i className="fa fa-temple"></i> */}
              <img src="./images/image.png" alt="logo" style={{ width: '100%' }} />
            </div>

            <div>
              <div className="temple-name- leftlogotext" >
                SREE PADMANABHASWAMY TEMPLE
              </div>

              <div className="temple-subtitle leftlogosub" >
                Thiruvananthapuram
              </div>
            </div>

          </div>

          {/* <div className="menu-heading">
                        MENU
                    </div> */}

        </div>

        {/* <h1 style={{ fontSize: "2rem", marginBottom: "10px",color:'white' }}>
          <span className="welcome">Sree Padmanabhaswamy Temple</span>
        </h1> */}
        {/* <p style={{ marginBottom: "15px" }}>
          Online Pooja Booking Available
        </p>
        <button
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            border: "none",
            borderRadius: "5px",
            backgroundColor: "#ff9800",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={() => window.location.href = "/pooja-booking"}
        >
          Book Pooja
        </button> */}
      </div>
    </div>
  );
};

export default Video;